<template>
    <span>
        <usuariosadd></usuariosadd>
    </span>
</template>

<script>
import Usuariosadd from '@/components/Cadastro-Usuarios-Adicionar';

export default {
    name: 'cadusuariosadd',
    components: {
        Usuariosadd
    }
};
</script>